import { TOCBUYORSELL, TOCOrderType, TOCProductCode, TOCValidationCode, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
export const currencyProducts = [
    { title: "NRML", value: "NRML", rank: 1 },
    { title: "MIS", value: "MIS", rank: 2 },
    { title: "BO", value: "BO", rank: 3 },
];
export const currencyOrder = [
    { title: "MARKET", value: "MARKET", rank: 1 },
    { title: "LIMIT", value: "LIMIT", rank: 2 },
    { title: "SL", value: "STOP_LIMIT", rank: 3 },
];
export const currencyValidity = [
    { title: "Day", value: "DAY", rank: 1 },
    { title: "IOC", value: "IOC", rank: 2 },
];
export var Evalidity;
(function (Evalidity) {
    Evalidity["ONE_5M"] = "5";
    Evalidity["ONE_10M"] = "10";
    Evalidity["ONE_30M"] = "30";
    Evalidity["ONE_1H"] = "120";
})(Evalidity || (Evalidity = {}));
export const timeperiodValidity = [
    { title: "5 Mins", value: Evalidity.ONE_5M },
    { title: "10 Mins", value: Evalidity.ONE_10M },
    { title: "30 Mins", value: Evalidity.ONE_30M },
    { title: "1 Hour", value: Evalidity.ONE_1H },
];
export const orderList = [
    { title: "Action", value: "Buy" },
    { title: "Product type", value: "F&O (NRML)" },
    { title: "Order type", value: "Market" },
    { title: "No of Lots", value: "2 (Qty: 100)" },
    { title: "Margin required", value: "14,806.75" },
    { title: "Available", value: "5,000.00" },
];
export const currencyConvertList = [
    { display: "Sell Order", value: TOCBUYORSELL.SELL },
    { display: "Buy Order", value: TOCBUYORSELL.BUY },
];
export const setUISectionsCurrency = (activeButton, isFNO = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let tempShowUiSections = {
        showStopLoss: false,
        showTargetPrice: false,
        showTriggerPrice: false,
        showTermsConditions: false,
        disabledLimitInput: false,
        discloseQty: false,
    };
    if ((((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === TOCProductCode.CNC ||
        ((_b = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === TOCProductCode.MIS ||
        ((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === TOCProductCode.NRML) &&
        (((_d = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === TOCOrderType.MARKET ||
            ((_e = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === TOCOrderType.LIMIT)) {
        if (((_f = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === TOCOrderType.MARKET) {
            tempShowUiSections.disabledLimitInput = true;
        }
        if (((_g = activeButton === null || activeButton === void 0 ? void 0 : activeButton.VALIDITY) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === TOCValidationCode.DAY) {
            tempShowUiSections.discloseQty = true;
        }
    }
    if ((((_h = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === TOCProductCode.CNC ||
        ((_j = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === TOCProductCode.MIS ||
        ((_k = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === TOCProductCode.NRML) &&
        ((_l = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === TOCOrderType.SL) {
        tempShowUiSections.showTriggerPrice = true;
    }
    if (((_m = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _m === void 0 ? void 0 : _m.toUpperCase()) === TOCProductCode.BO &&
        ((_o = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _o === void 0 ? void 0 : _o.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showTargetPrice = true;
        tempShowUiSections.showStopLoss = true;
        tempShowUiSections.showTermsConditions = true;
        tempShowUiSections.discloseQty = false;
    }
    return tempShowUiSections;
};
